import styled from 'styled-components'

import Media from '../Media'

export const List = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 5.2rem;
  column-gap: 8.6rem;

  ${({ theme }) => theme.breakpoints.up('desktop')} {
    align-items: flex-end;
  }

  ${({ theme }) => theme.breakpoints.down('desktop')} {
    grid-template-columns: repeat(2, 1fr);
    row-gap: 3.2rem;
    column-gap: 5.6rem;
  }

  ${({ theme }) => theme.breakpoints.down('mobile')} {
    grid-template-columns: repeat(1, 1fr);
    row-gap: 2.4rem;
    column-gap: 3.4rem;
  }
`

export const Item = styled(Media)``
